import React from "react";

import "./Header.css";

export default function Header(props) {
  return (
    <div className="text headersymbol">
      <div
      className="titleHeader"
        
      >
        EDIT USER : {props.item.username}
      </div>
      <div>
        {" "}
        <button
          onClick={() => {
            props.close();
          }}
          className={"dropbtnNavSub textwhite sell marginright"}
        >
          Close
        </button>
      </div>
    </div>
  );
}
